import { Chain, Checkout, Environment, PaymentError } from '@shared/data-access/interfaces';
import { Injectable, inject, signal } from '@angular/core';

import { Subject } from 'rxjs';
import { WINDOW } from '../window/window.service';

@Injectable({
  providedIn: 'root',
})
export class ExpressCheckoutDrawerService {
  private readonly openDrawerSubject = new Subject<void>();
  public open$ = this.openDrawerSubject.asObservable();

  private readonly orderPlacedSubject = new Subject<Checkout | null>();
  /**
   * Emits the submitted order when the payments MFE places it, so the drawer can confirm.
   * Null when the order was placed but could not be read back.
   */
  public orderPlaced$ = this.orderPlacedSubject.asObservable();

  private readonly paymentErrorsSubject = new Subject<PaymentError[]>();
  public paymentErrors$ = this.paymentErrorsSubject.asObservable();

  private readonly _isOpen = signal(false);
  /** Whether the express ("Buy Now") drawer is open; read by the cart page to suppress its overlay. */
  readonly isOpen = this._isOpen.asReadonly();

  setOpen(open: boolean): void {
    this._isOpen.set(open);
  }

  protected readonly window = inject(WINDOW);
  private readonly environment = inject(Environment);
  private readonly chain = inject(Chain);

  register(): void {
    // it's going to be implemented on upcoming story (CCPJ-7854)
  }

  open(): void {
    this.openDrawerSubject.next();
  }

  notifyOrderPlaced(checkout: Checkout | null): void {
    this.orderPlacedSubject.next(checkout);
  }

  reportPaymentErrors(errors: PaymentError[]): void {
    if (Array.isArray(errors)) {
      this.paymentErrorsSubject.next(errors);
    }
  }

  /**
   * Redirects to the order confirmation page
   */
  /* istanbul ignore next */
  public redirectToOrderConfirmation = (queryParams: string): void => {
    this.window.location.assign(
      `${this.environment.chk.step3}?${this.chain.checkoutConfirmationUrlParameters}${queryParams}`,
    );
  };
}
